import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Card, CardActionArea, CardContent } from '@material-ui/core';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const useStyles = buildUseStyles('DepositTypeCard', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.radius.md,
    height: 150,
    width: 230,
    margin: theme.spacing(1),
  },
  actionArea: {
    height: '100%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imgContainer: {
    borderRadius: '50%',
    height: 80,
    width: 80,
    background: theme.palette.facet.accentBlue20,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
}));

const DepositTypeCard = ({
  className,
  title,
  imgSrc,
  onClick,
  test,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { logEvent } = useEventTrackingLogEvent();

  return (
    <Card
      className={classNames(classes.root, className)}
      elevation={0}
      test={test}
    >
      <CardActionArea
        className={classes.actionArea}
        onClick={() => {
          logEvent(`Apex Account Funding Wizard: ${title} card clicked`);
          onClick();
        }}
      >
        <CardContent className={classes.cardContent}>
          <div className={classes.imgContainer}>
            <img src={imgSrc} alt={`${title}-logo`} />
          </div>
          <Typography
            color={'primaryGray'}
            weight="bold"
            variant={'subtitle2'}
          >
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

DepositTypeCard.defaultProps = {
  className: '',
  test: '',
};

DepositTypeCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  test: PropTypes.string,
};

export default DepositTypeCard;
